/**
 * Returns Tailwind text color class + semantic label for an AAQS score.
 * Single source of truth — used by AaqsRing, PortfolioStatsFooter, and others.
 */
export function getAaqsColorAndLabel(
  score: number | null | undefined,
): { colorClass: string; balkenClass: string; label: string } {
  /* ⭐ `balkenClass` seit Sammelauftrag 4 (07.10.2026): dieselbe Stufenfarbe als Fläche für den
     Zehner-Balken der Bewertungskarte — ausgeschrieben, damit Tailwind die Klasse erzeugt. */
  /*
    ─── ⛔⛔ TEXTFARBE UND FLÄCHENFARBE SIND GETRENNT (09.10.2026) ─────────────────────

    ⛔ DER BEFUND (Sammelauftrag 5, nachgemessen im Browser am 09.10.2026): `colorClass` und
    `balkenClass` trugen DIESELBE Tailwind-Farbe. Diese Töne sind für eine FLÄCHE gemacht; als
    Schrift auf weißem Kachelgrund halten sie 1,67 bis 2,47:1 statt der verlangten 4,5:1.

    ⭐ `colorClass` geht jetzt über TOKENS, die sich mit dem Thema drehen — hell dunklere Töne
    derselben Familie, dunkel die bisherigen. `balkenClass` bleibt unverändert: Ring und Balken
    sind Fläche, und für sie gilt die Textgrenze nicht.
    ⚠️ „Kritisch“ und „Keine Daten“ brauchten kein neues Token: `--status-danger` (6,47 / 6,27)
    und `--text-muted` (6,31 / 6,77) halten die Grenze in beiden Themen schon. `text-slate-600`
    tat es NICHT — 2,29:1 im dunklen Thema, gemessen.
    ⚠️ Die Zahlen stehen an den Tokens in `app/shared/design-tokens/semantic.ts`.
  */
  if (score == null) return { colorClass: 'text-fg-muted', balkenClass: 'bg-slate-600', label: 'Keine Daten' };
  /* ⭐ Deutsch seit Sammelauftrag 2 (07.10.2026) — die eine Stelle für alle fünf Stufenwörter. */
  if (score >= 9) return { colorClass: 'text-aaqs-ausgezeichnet', balkenClass: 'bg-emerald-400', label: 'Ausgezeichnet' };
  if (score >= 7) return { colorClass: 'text-aaqs-solide', balkenClass: 'bg-emerald-500', label: 'Solide' };
  if (score >= 5) return { colorClass: 'text-aaqs-mittel', balkenClass: 'bg-amber-400', label: 'Mittel' };
  if (score >= 3) return { colorClass: 'text-aaqs-schwach', balkenClass: 'bg-orange-400', label: 'Schwach' };
  return { colorClass: 'text-danger', balkenClass: 'bg-danger', label: 'Kritisch' };
}

/*
  ⭐ `getAaqsBgClass` IST AM 31.08.2026 ENTFALLEN. Sie faerbte den Hintergrund des rechteckigen
  AAQS-Kastens auf der Positionsdetailseite — der einzigen Stelle, die AAQS nicht als Ring zeigte.
  Mit dem Ring fiel ihr letzter Aufrufer weg, und `knip` meldete sie als tote Ausfuhr.

  ⛔ Wer sie zurueckholt, baut den Kasten zurueck: Zwei Darstellungen fuer dieselbe Kennzahl waren
  genau der Befund. Die Farben kommen aus `getAaqsColorAndLabel` — dieselben Schwellen, eine Form.
*/
